import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createDraftMessage } from "../../../redux/slices/messagesSlice";
import { Form, Button } from "react-bootstrap";

const DraftMessage = () => {
  const dispatch = useDispatch();
  const [messageData, setMessageData] = useState({
    recipient_id: "",
    content: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMessageData({ ...messageData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createDraftMessage(messageData));
    setMessageData({ recipient_id: "", content: "" });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Recipient ID</Form.Label>
        <Form.Control
          type="text"
          name="recipient_id"
          value={messageData.recipient_id}
          onChange={handleInputChange}
          placeholder="Enter recipient ID"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Message Content</Form.Label>
        <Form.Control
          as="textarea"
          name="content"
          value={messageData.content}
          onChange={handleInputChange}
          placeholder="Enter your message"
          rows={5}
          required
        />
      </Form.Group>
      <Button variant="primary" type="submit">
        Send Message
      </Button>
    </Form>
  );
};

export default DraftMessage;